import React from 'react';
export function Footer() {
  return <footer className="bg-black py-12 border-t border-truco-surface" data-id="element-55">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-56">
        <p className="text-truco-cream font-heading font-bold mb-6" data-id="element-57">
          © 2024 LA BIBLIA DEL TRUCO ARGENTINO. Todos los derechos reservados.
        </p>

        <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-sm text-truco-creamMuted mb-8" data-id="element-58">
          <a href="#" className="hover:text-truco-gold transition-colors" data-id="element-59">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-truco-gold transition-colors" data-id="element-60">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-truco-gold transition-colors" data-id="element-61">
            Contacto
          </a>
        </div>

        <p className="text-xs text-truco-creamMuted/50 max-w-3xl mx-auto leading-relaxed" data-id="element-62">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
      </div>
    </footer>;
}